"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init = function (args, errorLog) {
    window.onerror = function (message, filename, lineno, colno, error) {
        console.error(error);
        errorLog("==== onerror ====\n    message:".concat(message, "\n    filename:").concat(filename, "\n    lineno:").concat(lineno, "\n    colno:").concat(colno, "\n    message:").concat(error === null || error === void 0 ? void 0 : error.message, "\n    errorStack:").concat(error === null || error === void 0 ? void 0 : error.stack));
        return true;
    };
    window.addEventListener("unhandledrejection", function (event) {
        console.error(event);
        var reason = event.reason;
        // 防止默认处理（例如将错误输出到控制台）
        event.preventDefault();
        errorLog("==== unhandledrejection ====\n        message:".concat(reason.message, "\n        errorStack:").concat(reason.stack));
    });
    window.addEventListener("error", function (event) {
        console.error(event);
        // eslint-disable-next-line prefer-destructuring
        var target = event.target;
        event.preventDefault();
        if (target === null || !target.tagName)
            return;
        var tagName = target.tagName.toUpperCase();
        errorLog("==== error ====\n    tagName:".concat(tagName, "\n    targetSrc:").concat(target.src, "\n    message:\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25"));
        // eslint-disable-next-line consistent-return
        return true;
    }, true);
};
exports.default = init;
